<div class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
  <div class="bg-white p-6 rounded shadow-md">
    <p class="mb-4">{{ message }}</p>
    <div class="flex justify-end space-x-4">
      <button (click)="cancel()" class="bg-gray-500 text-white px-4 py-2 rounded">Cancelar</button>
      <button (click)="confirm()" class="bg-red-500 text-white px-4 py-2 rounded">Confirmar</button>
    </div>
  </div>
</div>
